import { Fragment } from "react";

export const LuxeMarquee = ({ words = [], testId = "luxe-marquee" }) => {
  const list = words.map((w) => (w || "").trim()).filter(Boolean);
  if (!list.length) return null;
  const Row = ({ hidden }) => (
    <div className="flex shrink-0 items-center" aria-hidden={hidden ? "true" : undefined}>
      {list.map((w, i) => (
        <Fragment key={i}>
          <span className="whitespace-nowrap px-6 font-display text-2xl sm:px-9 sm:text-4xl">{w}</span>
          <span className="text-[hsl(345_80%_84%)]" aria-hidden="true">
            <svg viewBox="0 0 24 24" className="h-4 w-4 sm:h-5 sm:w-5" fill="currentColor"><path d="M12 0l2.6 9.4L24 12l-9.4 2.6L12 24l-2.6-9.4L0 12l9.4-2.6z" /></svg>
          </span>
        </Fragment>
      ))}
    </div>
  );
  return (
    <div data-testid={testId} className="on-dark group relative overflow-hidden bg-espresso py-5 text-[hsl(350_60%_97%)] sm:py-7">
      <div className="luxe-marquee-track flex w-max group-hover:[animation-play-state:paused]">
        <Row />
        <Row hidden />
      </div>
    </div>
  );
};
